<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div style="margin-bottom:16px">
            <span class="title">机构目录</span>
            <el-button type="primary" style="float:right" @click="addOrg" :disabled="disSwich">添加成员</el-button>
          </div>
          <div id="custom-tree" v-for='(items, index) in data' :key="index">
            <div class="group-item">
              <div class="active-group" @click.stop=handleNodeClick(items,$event,true)>
                <i class="el-tree-node__expand-icon el-icon-caret-right" />
                <i class="el-icon-poc" />
                <!-- <img
                class="file"
                src="@/assets/icon.png"
              /> -->

                <div class="title-group">
                  <div class="lable-text">{{items.name}}</div>
                  <!-- <div class="icon-list">
                    <i class="el-icon-edit" />
                    <i class="el-icon-delete" />
                  </div> -->
                </div>
              </div>
              <div v-for='(itemss, indexs) in items.child' v-if='items.child.length>=1' :key="indexs"
                class="option-group" @click.stop=handleNodeClick(itemss,$event,false)>
                {{itemss.name}}
                <!-- <div class="icon-list">
                <i class="el-icon-edit" />
                <i class="el-icon-delete" />
              </div> -->
              </div>
            </div>
          </div>
          <!-- <el-tree
          v-if="isInit"
            :data="data"
            :props="defaultProps"
            :default-expand-all="false"
            @node-click="handleNodeClick"
            node-key="id"
          >
            <div
              slot-scope="{ node, data }"
              class="custom-tree-node"
            >
              <div class="menuIcon-content">
                <i class="file" />
                <span class="group-list">{{ node.label }}</span>
                <span class="menuIcon">
                  <i
                    class="el-icon-edit"
                    style="margin-right:16px"
                    @click.stop="edit(data)"
                  />
                  <i
                    class="el-icon-delete"
                    @click.stop="remove(data)"
                  />
                </span>

              </div>

            </div>
          </el-tree> -->
        </div>
      </el-col>
      <el-col :span="18">
        <div class="grid-content bg-purple pageContent">
          <div style="margin-bottom:16px;position: relative;">
            <span class="title">机构信息</span>
            <el-button type="primary" style="float:right" :disabled="isAble" @click="remove">移除成员</el-button>
            <transition name="fade">
              <div class="tip" v-show="tipFlag">
                <i class="tipIcon"></i>已选中<span class="data">{{ dataCount }}</span>项
              </div>
            </transition>
          </div>

          <div class="orinfo">

            <div v-if="flag">
              <!-- 123 -->
              <el-table
              :key="tableKey"
              ref="multipleTable"
              v-loading="listLoading"
              stripe
              :data="tableDataFile"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              @cell-mouse-enter="operateShow"
              @cell-mouse-leave="operateClose"
            >
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="idx" label="序号" width="60">
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
        
                label="员工工号"
                min-width="100px"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.code }}</span>
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                label="员工姓名"
                min-width="100px"
              >
                <template slot-scope="scope">{{ emptyDeal(scope.row.name) }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                label="性别"
                min-width="100px"
              >
                <template slot-scope="scope">{{ scope.row.sex==1?"男":"女" }}</template>
              </el-table-column>
              <el-table-column
              :show-overflow-tooltip="true"
              label="毕业院校"
              min-width="100px"
            >
              <template slot-scope="scope">{{ scope.row.graduatedSchool }}</template>
            </el-table-column>
            <el-table-column
            :show-overflow-tooltip="true"
            label="学历"
            min-width="100px"
          >
            <template slot-scope="scope">{{ scope.row.education }}</template>
          </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                label="户籍地址"
                min-width="100px"
              >
                <template slot-scope="scope">{{ emptyDeal(scope.row.censusArea) }}</template>
              </el-table-column>
             
              <el-table-column
                :show-overflow-tooltip="true"
                label="职位"
                min-width="100px"
              >
                <template slot-scope="scope">{{ emptyDeal(scope.row.position) }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                width="200px"
                label="操作"
              >
                <template
                  slot-scope="scope"
                  class="icon"
                >
                  <div class="icon">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="是否主管"
                      placement="top"
                    >
                      <i
                        class="el-icon-change"
                        style="margin-right:16px"
                        @click="changePosition(scope.row.id)"
                      />
                    </el-tooltip>
                   
        
                  </div>
                </template>
              </el-table-column>
            </el-table>
              <div class="mt10">
                <el-pagination :current-page="pageInfo.currentPage" :page-sizes="pageInfo.pageSizeList"
                  :page-size="pageInfo.limit" layout="total, prev, pager, next, jumper" :total="pageInfo.allCount"
                  @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-pagination>
              </div>

            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <template>
      <div v-if="isShow">
        <AddCom v-on:closeDialog="closeDialog" :currentgroup="currentAssociation" :add-id="officeId"
          @returnResult="fetchData" />>
      </div>
    </template>
    <!-- 是否主管 -->
    <template>
      <div v-if="isChange">
        <Position v-on:closeDialog="closeDialog" 
        :changeId="userId"
          @returnResult="fetchData" />
      </div>
    </template>
  </div>
</template>
<script>
  import jq from 'jquery'
  import { orgTrans, emptyTrans, sortDataList,roleTrans } from '@/api/dataTrans.js'
  import { personList, getAllDepartList, removeRole } from '@/api/system'
  import AddCom from './addCom.vue'
  import Position from './position.vue'
  export default {
    components: { AddCom,Position },
    computed: {
      tableDataFile() {
        const _this = this
        _this.tableData.forEach((item, idx) => {
          item.idx = idx + 1
        });
        return _this.tableData
      },
      isAble() {
        let result = true
        if (this.multipleSelection.length) {
          result = false
        }
        return result
      }
    },
    data() {
      return {
        isInit: false,
        currentAssociation: {},
        pageInfo: {
          limit: 10,
          allCount: 0,
          currentPage: 1,
          currentPageCount: 0,
          showEdit: false // 是否显示快捷编辑代码框
        },
        submitData: {
          name: '',
          type: '1',
          desc: ''
        },
        tableKey:0,
        listLoading:false,
        data: [],
        defaultProps: {
          children: 'child',
          label: 'name',
          value: 'id'
        },
        flag: true,
        type: null,
        info: null,
        isShow: false,
        systemList: [{
          address: "fangwend",
          businessType: 1,
          code: "测试系统1",
          createTime: "2020-02-24 15:04:55",
          id: 112,
          name: "测试子系统-fan",
          sort: 2
        }],
        value: null,
        tableData: [],
        multipleSelection: [],
        currentId: null,
        removeId: "",
        officeId: "",
        dataCount: 0,
        tipFlag: false,
        disSwich: true,
        isChange:false,
        userId:null
      }
    },

    mounted() {
      this.getList()
      this.fetchData()
      // document.getElementById('menuIcon1').style.background = "#F5F7FA";
      // this.initStyle("#F5F7FA")
      // document.getElementsByClassName("el-tree-node__content").onclick = function (even) {
      //   window.console.log("11111")
      //   alert("sdsdf")
      //   even.background = "#F5F7FA"
      // }
    },
    watch: {
      multipleSelection: {
        deep: true,
        handler: function (val, old) {
          if (this.multipleSelection.length > 0) {
            this.tipFlag = true
            this.tipEnter()
          } else {
            this.tipFlag = false
            this.tipLeave()
          }
          this.dataCount = this.multipleSelection.length
        }
      }
    },
    methods: {
      closeDialog() {
        this.isShow = false
        this.isChange=false
      },
      changePosition(data){
        this.userId=data
        console.log(data)
         this.isChange=true
      },
      emptyDeal(_val) {
      return emptyTrans(_val)
    },
    operateShow(row, column, cell, event) {
      event.path[1].cells[9].children[0].children[0].style.display = 'block'
    },
    operateClose() {
      event.path[1].cells[9].children[0].children[0].style.display = 'none'
    },
      getDefaultObj(arr) {
        const _this = this
        let result = {}
        var recursion = function (arr) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[0].children) {
              recursion(arr[0].children)
            } else {
              result = arr[0]
              return
            }
          }
        }
        recursion(arr[0].children)
        this.currentAssociation = result
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      //table选择
      handleSelectionChange(val) {
        // window.console.log(JSON.stringify(JSON.stringify(val)))
        this.multipleSelection = val
      },
      fetchData() {
        const _this = this
        const paramObj = {
          officeId: this.currentId,
          pageNo: this.pageInfo.currentPage,
          pageSize: this.pageInfo.limit
        }
        personList(paramObj).then(res => {
          if (res && res.code == 0) {
            // this.type = res.data[0].type
            // this.info = res.data[0]
            _this.tableData = res.data.items
            this.pageInfo.allCount = res.data.total
          }
        })
      },

      initStyle(_val) {
        var initEl = document.getElementsByClassName("el-tree-node")[0]
        if (initEl) {
          initEl.style.background = _val
        } else {
          setTimeout(function () {
            document.getElementsByClassName("el-tree-node")[0].style.background = _val
          }, 2000)
        }
      },
      getList() {
        const _this = this
        // getAllDepartList().then(res => {
        //   if (res && res.code == 0) {
        //     this.data = res.data
        //   }
        // })
        getAllDepartList(function (res) {
          if (res && res.code == 0) {
            _this.currentId = res.data[0].id
            _this.data = res.data
          }
          // setTimeout(function(){
          //   _this.initStyleinitStyle("#F5F7FA")
          // },1000)
          _this.isInit = true
        })

      },
      addOrg() {
        this.isShow = true
      },
      remove() {
        // window.console.log(this.multipleSelection)

        // const groupName = this.currentAssociation.label
        const num = this.multipleSelection.length
        const arr = []
        const arr1 = []
        for (var i = 0; i < this.multipleSelection.length; i++) {
          arr.push(this.multipleSelection[i].id)
          arr1.push(this.multipleSelection[i].name)
        }
        this.removeId = arr.toString()
        const name = arr1.toString()
        this.$confirm('确定移除' + name + '的' + num + '名成员吗？', '确认移除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          removeRole({
            ids: this.removeId
          }).then(res => {
            if (res && res.code == 0) {
              this.$message.success("移除成功")
              this.fetchData()
            }
          })
        }).catch(() => { })
      },
      //树形选择框选择
      handleNodeClick(data, that, isParent) {
        this.disSwich = false
        this.styleRender(that, isParent)
        this.currentId = data.id
        this.officeId = data.id
        window.console.log(data.id)
        // this.initStyle("none");
        this.currentAssociation = data
        this.fetchData()
        this.flag = true
      },
      handleSizeChange(val) {
        this.pageInfo.limit = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val
        this.fetchData()
      },
      styleRender(that, isParent) {
        if (isParent) {
          jq("#custom-tree .option-group").animate({ height: '0px' }, 0.5)
          jq("#custom-tree .active-group").removeClass('active')
          jq("#custom-tree .el-tree-node__expand-icon").removeClass('expanded')
          jq(that.currentTarget).addClass('active')
          jq(that.currentTarget).children('.el-tree-node__expand-icon').addClass('expanded')
          jq(that.currentTarget).siblings('.option-group').animate({ height: '26px' }, 0.5)
        } else {
          jq("#custom-tree .option-group").removeClass('active-option')
          jq(that.currentTarget).addClass('active-option')
        }

        that.stopPropagation()
      },
      tipEnter() {
        jq(".orinfo").addClass('leave')
        jq(".orinfo").removeClass('enter')
      },
      tipLeave() {
        jq(".orinfo").addClass("enter")
        jq(".orinfo").removeClass('leave')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mt10 {
    margin-top: 24px !important;
    float: right;
  }

  .enter {
    top: 0px !important;
  }

  .leave {
    top: 32px !important;
  }

  .orinfo {
    margin: 0 auto;
    position: relative;
    top: 0px;
    transition: all 0.3s ease;
  }

  .pageContent {
    border-left: 1px solid #e8e8e8;
    min-height: calc(100vh - 218px);
    padding: 0 24px;
  }

  .title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
  }

  body .app-wrapper-new-style .app-container {
    padding-left: 24px;
    padding-top: 32px;
  }

  .el-select {
    width: 100%;
  }

  .el-tree {
    margin-top: 24px;
    font-size: 12px;
  }

  .icon {
    display: none;
  }

  .file {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: contain;
    background-image: url("../../../../assets/icon.png");
    margin-right: 8px;
    position: relative;
    top: 3px;
  }

  .el-tree-node__content .menuIcon {
    display: none;
  }

  .el-tree-node__children .menuIcon-content {
    position: relative;
    padding-right: 60px;
  }

  .el-tree-node__children .menuIcon {
    position: absolute;
    right: 0;
    display: none;
    // display: inline-block;
    top: 5px;
  }

  // .el-tree-node__content:hover .menuIcon {
  //   display: inline-block;
  // }
  // .el-tree-node__children .custom-tree-node :hover .menuIcon {
  //   display: inline-block;
  // }
  .el-tree-node__content {
    background-color: #f5f7fa;
  }

  /deep/.el-tree-node__label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
  }

  .tip {
    background-color: #FFFAF5;
    padding: 8px 0px 8px 16px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    position: absolute;
    top: 40px;
    width: 100%;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  /* v-enter-active 【入场动画的时间段】 */
  /* v-leave-active 【离场动画的时间段】 */
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s ease;
  }

  .data {
    color: #FFA940;
  }

  #custom-tree {
    /* width: 300px; */
    font-size: 12px;
    color: #606266;
    line-height: 26px;
    background: #ffffff;
    cursor: pointer;
    position: relative;

    .file {
      width: 16px;
      height: 16px;
      display: inline-block;
      background-size: contain;
      margin-right: 8px;
      position: relative;
      top: 3px;
    }

    .icon-list {
      margin-left: 10px;
      display: none;
      position: absolute;
      right: 8px;

      i {
        margin-left: 10px;
      }
    }

    .title-group {
      display: inline-block;
    }

    .title-group .lable-text,
    .option-group .lable-text {
      width: 150px;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      margin-bottom: -9px;
    }

    .el-tree-node__expand-icon {
      cursor: pointer;
      font-size: 12px;
      transform: rotate(0deg);
      transition: transform 0.5s ease-in-out;
    }

    .expanded {
      transform: rotate(90deg);
    }

    .option-group {
      height: 0px;
      padding-left: 40px;
      overflow: hidden;
    }

    .active-group:hover,
    .option-group:hover {
      background: rgba($color: #ffa940, $alpha: 0.1);

      .icon-list {
        display: inline-block;
      }
    }

    .active {
      background: rgba($color: #ffa940, $alpha: 0.85);
      color: #ffffff;

      .el-tree-node__expand-icon {
        color: #ffffff;
      }

      .icon-list {
        display: inline-block;
      }

      .iconfont {
        color: rgba(255, 255, 255, 0.85)
      }

      .el-icon-poc {
        background-image: url("../../../../assets/pocket.png");
      }
    }

    .active:hover {
      background: rgba($color: #ffa940, $alpha: 0.85);
    }

    .active-option {
      color: rgba($color: #ffa940, $alpha: 0.85);

      .icon-list {
        display: inline-block;
      }
    }
  }
</style>